import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './UpvoteAndComments.module.sass';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';
import scrollToElement from '../../../services/smooth_scroll';
import arrowTopIcon from '../../../../images/icons/arrow-top.svg';
import arrowTopSelectedIcon from '../../../../images/icons/arrow-top-selected.svg';
import arrowBottomIcon from '../../../../images/icons/arrow-bottom.svg';
import arrowBottomSelectedIcon from '../../../../images/icons/arrow-bottom-selected.svg';
import commentIcon from '../../../../images/icons/comment.svg';
import { totalReviewsSelector } from '../../../product/selectors/reviews';
import { campaignsActions } from '../../../campaigns/actions';

function UpvoteAndComments(props) {
  const {
    campaign, upvote, downvote, totalReviews = 0, className,
  } = props;

  return (
    <div className={`${styles.comments} ${className}`}>
      <ClickableDiv
        className={styles.icon}
        onClick={() => {
          if (campaign.is_upvoted) { return; }

          upvote(campaign.id);
        }}
      >
        <img src={campaign.is_upvoted ? arrowTopSelectedIcon : arrowTopIcon} alt="upvote" />
      </ClickableDiv>
      <div className={styles.text}>
        {campaign.upvotes_total}
      </div>
      <ClickableDiv
        className={styles.icon}
        onClick={() => {
          if (campaign.is_downvoted) { return; }

          downvote(campaign.id);
        }}
      >
        <img src={campaign.is_downvoted ? arrowBottomSelectedIcon : arrowBottomIcon} alt="downvote" />
      </ClickableDiv>
      { totalReviews && (
      <ClickableDiv
        className={styles.container}
        onClick={() => {
          scrollToElement('react-reviews');
        }}
      >
        <div className={styles.icon}>
          <img src={commentIcon} alt="" />
        </div>
        <div className={styles.text}>
          {totalReviews}
          {' '}
          Comments
        </div>
      </ClickableDiv>
      )}
    </div>
  );
}

UpvoteAndComments.propTypes = {
  campaign: PropTypes.shape({
    id: PropTypes.number,
    upvotes_total: PropTypes.number,
    is_upvoted: PropTypes.bool,
    is_downvoted: PropTypes.bool,
  }).isRequired,
  totalReviews: PropTypes.number,
  upvote: PropTypes.func.isRequired,
  downvote: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const mapStateToProps = (state) => ({
  totalReviews: totalReviewsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  upvote: (campaignId) => dispatch(
    campaignsActions.upvoteRequest({ campaignId }),
  ),
  downvote: (campaignId) => dispatch(
    campaignsActions.downvoteRequest({ campaignId }),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpvoteAndComments);
